import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { HtmlPreviewNodeView } from "./html-preview-node-view";

export const HtmlPreviewNode = Node.create({
  name: "htmlPreview",

  group: "block",
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      code: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-html-preview") ?? "",
        renderHTML: (attrs) => ({
          "data-html-preview": attrs.code,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-html-preview]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(HtmlPreviewNodeView);
  },
});
